'use strict';

(function($) {
    $(function() {

        $(window).scroll(function(){
            $('.js-scroll-effect').css('transform','translateY(' + ($(window).scrollTop() / 10) + 'px)');
            $('.js-scroll-xs-effect').css('transform','translateY(' + ($(window).scrollTop() / 30) + 'px)');
        });

    });
})(jQuery);
